module.exports = __webpack_public_path__ + "img/papuanewguinea.283ac927.svg";